import React, { useMemo } from 'react';
import { Empty, Table } from 'antd';
import { useSelector } from 'react-redux';

import { CommonTableProps } from '../../../../crm/interfaces/common.interface';
import { ChatFilters, ChatProps } from '../interface/chats.interface';
import { useAppDispatch } from '../../../../../store';
import { dynamicPagination } from '../../../../../utils/common/dynamicPagination';
import {
    selectSelected,
    setSelectedRows,
    setSelectedRowsItem,
} from '../../../../common/store/selectionSlice';
import { getColumns } from '../utils/getColumns';

export const ChatsTable = ({
    filters,
    source,
    loading,
    updateFilters,
    getColumnSearchProps,
}: CommonTableProps<ChatProps, ChatFilters>) => {
    const dispatch = useAppDispatch();

    const pagination = useMemo(
        () => dynamicPagination(filters, updateFilters, source.total, 'Чатов'),
        [filters, updateFilters, source.total]
    );

    const { selectedRows } = useSelector(selectSelected);

    const rowSelection = {
        selectedRowKeys: selectedRows,
        onChange: (keys: React.Key[], items: ChatProps[]) => {
            dispatch(setSelectedRows(keys as number[]));
            dispatch(setSelectedRowsItem(items));
        },
    };

    return (
        <Table
            loading={loading}
            rowSelection={rowSelection}
            rowKey={community => community.id}
            locale={{ emptyText: <Empty description='Нет чатов' /> }}
            dataSource={source.items}
            pagination={pagination}
            columns={getColumns(getColumnSearchProps, updateFilters, filters)}
        />
    );
};
